import { ClientPaymentsList } from './ClientPaymentsList.main';
import { ClientPaymentsHeader } from './components/ClientPaymentsHeader';

export { ClientPaymentsList, ClientPaymentsHeader };
